import { ROUTES } from 'Utils/constants'

// Screens that show the shopping cart. Every other screen either empties the
// cart on entry (new quote, quote by product) or reprices the quote lines when
// it loads them (edit, clone), so repricing elsewhere is wasted work.
export const CART_ROUTES = [
  ROUTES.createQuote,
  ROUTES.cloneQuote,
  ROUTES.editQuoteHeaderId,
  ROUTES.quoteProduct,
  ROUTES.generateQuote,
  ROUTES.materialsPreOrder,
]

export const isCartRoute = (pathname = '') =>
  CART_ROUTES.some(route => pathname.startsWith(route))
